<template>
  <ModalLayout icon="upload-slim" title="Upload creatives" @close="close">
    <ElForm :model="creatives" ref="localForm" @submit.prevent.native>
      <!-- Choose a type -->
      <ElFormItem>
        <div class="font-bold"><span class="text-danger">* </span>Choose a format</div>
        <el-select v-model="creatives.type" placeholder="Select" class="w-full" @change="onFormatChange" :loading="loadingTypes">
          <el-option v-for="(option, index) in typesOptions" :key="index" :label="option.label" :value="option.value" />
        </el-select>
      </ElFormItem>
      <!-- Add files -->
      <ElFormItem>
        <div class="font-bold"><span class="text-danger">* </span>Add files</div>
        <UploadFiles ref="uploadFile" :validate="false" v-model="creatives.files" :disabled="!creatives.type">
          <template slot="tip">JPG/JPEG/PNG/MP4/AVI files with a size less than 5MB</template>
        </UploadFiles>
      </ElFormItem>
    </ElForm>

    <!-- Footer -->
    <template slot="footer">
      <el-button class="font-semibold" @click="close">Cancel</el-button>
      <el-button
        class="font-semibold ml-0"
        @click="ctaUpload"
        icon="el-icon-upload"
        type="primary"
        :disabled="!creatives.files || creatives.files.length === 0 || loading"
        :loading="loading"
      >
        Upload
      </el-button>
    </template>
  </ModalLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalLayout from './ModalLayout.vue'
import UploadFiles from '../parts/UploadFiles.vue'

export default {
  name: 'UploadCreatives',
  components: { ModalLayout, UploadFiles },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      loadingTypes: false,
      creatives: {
        type: null,
        name: '',
        files: [],
      },
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['gamPresets']),
    typesOptions() {
      return this.gamPresets.map((type) => ({
        label: type.name,
        value: type.id,
      }))
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    onFormatChange() {
      this.creatives.files = []

      const selectedType = this.typesOptions.find((option) => option.value === this.creatives.type)
      this.creatives.name = selectedType ? selectedType.label : ''
    },

    async ctaUpload() {
      if (!this.creatives.type || !this.creatives.files.length) return
      this.loading = true
      try {
        await this.$store.dispatch('socialBoostCampaign/saveCreativesForm', {
          asset_id: this.meta.asset.id,
          gam_ad_unit_preset_id: this.creatives.type,
          name: this.creatives.name,
          files: this.creatives.files,
        })
        this.close()
        this.$Modal.parent.init()
      } catch (error) {
        console.error('Upload failed:', error)
      } finally {
        this.loading = false
      }
    },
    async init() {
      this.loadingTypes = true
      await this.$store.dispatch('socialBoostCampaign/getCreativeTypes', {
        campaignId: this.$route.params.id,
      })
      this.loadingTypes = false
    },
  },
}
</script>
